export const MPN_PAGES_TITLE = [
  { path: "/mpn/requests", title: "MPN Requests" },
  { path: "/mpn/search", title: "Search MPN" },
  { path: "/mpn/create", title: "Create New MPN" },
  { path: "/mpn/dashboard", title: "MPN Last Integrations" },
]